import $ from 'jquery';
import { isWindow } from 'stdjs/utilities';

export function initDataTableResizerFunction(dataTable, $resizeContainer, $boundingContainer, options = {} ){
                
    var options = $.extend({
        extraWidthModifier: 0                
    }, options);
    
    /**
     * Set up a resize function for the table
     */
    var resizeFunction = function(){
        
        /**
         * Calculate the new container height
         */
        var newHeight = calcNewContainerHeight( $boundingContainer, $resizeContainer );
        
        /**
         * Calculate the new container width
         */
        var newWidth = calcNewContainerWidth( $boundingContainer, $resizeContainer, options.extraWidthModifier );                
        
        /**
         * Resize the resize container to these dimensions
         */
        $resizeContainer.css({
            "max-height": newHeight, 
            "height": newHeight,
            "max-width": newWidth, 
            "width": newWidth
        });
        
        /**
         * Now (it was like this before, not sure why), set the
         * height of the resize container and its parent to 100%
         */
        $resizeContainer.height("100%");
        //$resizeContainer.parent().height("100%");
        
        /**
         * Now redraw the table
         */
        dataTable.draw();
        
    }
    
    /**
     * Now we have our function, set it up to run on window resize
     */
    $(window).resize(function(){        
        resizeFunction();
    });

    /**
     * Set up the function to run when the sidenav menu is toggled
     */
    new ResizeObserver(function(){
        resizeFunction();
    }).observe($(".main-content")[0])
        
    /**
     * And run it once now to get things going
     */         
    resizeFunction();
    
    /**
     * Return the function should anyone want to call it themselves.
     */
    return resizeFunction;
    
}

export function initSideNavResizingObserver( table ){
    new ResizeObserver(function(){
        table.draw( false );
    }).observe($(".main-content")[0])
} 

function getOffsetTopRelative( $element, $relativeTo ){
    if ( isWindow( $relativeTo[0] ) ){
        return $element.offset().top;
    }     
    
    return $element.offset().top - $relativeTo.offset().top;
}    
   
function getOffsetLeftRelative( $element, $relativeTo ){
    if ( isWindow( $relativeTo[0] ) ){
        return $element.offset().left;
    }  
    return $element.offset().left - $relativeTo.offset().left;
} 


function calcNewContainerHeight( $boundingContainer, $resizeContainer, bottomMargin = 0 ){
    
    /**
     * Get the height of the bounding container
     */
    var boundingContainerHeight = $boundingContainer.height()
    
    /**
     * Find the top of the resize container relative to the bounding container
     */
    var resizeContainerOffset = getOffsetTopRelative( $resizeContainer, $boundingContainer );
    
    /**
      * calc the new height
      */
    return boundingContainerHeight - resizeContainerOffset - bottomMargin;
}

function calcNewContainerWidth( $boundingContainer, $resizeContainer, extraWidthModifier ){
    
    /**
     * Get the width of the bounding container
     */
    var boundingContainerWidth = $boundingContainer.width();

    /**
     * Find the left of the resize container relative to the bounding container
     */
    var resizeContainerOffset = getOffsetLeftRelative( $resizeContainer, $boundingContainer );
    
    /**
     * calc the new width
     */
    return boundingContainerWidth - resizeContainerOffset - extraWidthModifier;
    
}

    